
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

export default function ProBanner() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className={`relative overflow-hidden transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
        <div className="relative rounded-3xl overflow-hidden">
          {/* Background Image */}
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/d3396f7dfb7c1f75bccd020d1730ff35.jpg"
              alt="Pro Banner Background"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/75 to-gray-900/60"></div>
          </div>

          {/* Content */}
          <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8 px-8 sm:px-12 lg:px-16 py-12 lg:py-16">
            {/* Left: Text */}
            <div className="flex-1 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent/20 border border-accent/30 rounded-full mb-5">
                <i className="ri-vip-crown-2-fill text-accent text-lg w-5 h-5 flex items-center justify-center"></i>
                <span className="text-accent font-bold text-sm">{t('proBanner.badge')}</span>
              </div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white mb-4 leading-tight">
                {t('proBanner.title')}
              </h2>
              <p className="text-lg text-white/80 font-semibold max-w-xl mb-6">
                {t('proBanner.subtitle')}
              </p>

              {/* Feature Pills */}
              <div className="flex flex-wrap gap-3 justify-center lg:justify-start mb-8">
                <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/10">
                  <i className="ri-speed-up-line text-primary text-lg w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-white text-sm font-bold whitespace-nowrap">{t('proBanner.f1')}</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/10">
                  <i className="ri-hd-line text-primary text-lg w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-white text-sm font-bold whitespace-nowrap">{t('proBanner.f2')}</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/10">
                  <i className="ri-stack-line text-primary text-lg w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-white text-sm font-bold whitespace-nowrap">{t('proBanner.f3')}</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/10">
                  <i className="ri-advertisement-line text-primary text-lg w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-white text-sm font-bold whitespace-nowrap">{t('proBanner.f4')}</span>
                </div>
              </div>
            </div>

            {/* Right: Price + CTA */}
            <div className="flex-shrink-0 text-center">
              <div className="bg-white/10 backdrop-blur-md rounded-2xl border border-white/15 p-8 min-w-[280px]">
                <div className="flex items-baseline justify-center gap-1 mb-2">
                  <span className="text-white/60 text-lg font-bold line-through">$29</span>
                  <span className="text-5xl font-black text-white">$15</span>
                  <span className="text-white/70 text-lg font-bold">/mo</span>
                </div>
                <p className="text-primary text-sm font-bold mb-6">{t('proBanner.discount')}</p>
                <Link
                  to="/pricing"
                  className="block w-full px-8 py-4 bg-gradient-to-r from-accent to-accent-600 text-white rounded-xl font-black text-base hover:shadow-2xl hover:shadow-accent/40 transition-all cursor-pointer whitespace-nowrap text-center"
                >
                  {t('proBanner.cta')}
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
                <p className="text-white/50 text-xs font-semibold mt-4">{t('proBanner.guarantee')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
